import React from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import EnterBulkLocations from './enter-bulk-locations';
import SearchResultsTabs from './search-results-tabs';
import { useBulkLocationsSearchContext } from './bulk-locations-search-provider';
import WarningBanner from './warning-banner';

const useStyles = makeStyles({
  wrapper: {
    marginBotton: tokens.spacingVerticalMNudge,
  },
});

const BulkLocations = () => {
  const classes = useStyles();
  const { searchResults } = useBulkLocationsSearchContext();

  return (
    <div className={classes.wrapper}>
      <WarningBanner />
      <EnterBulkLocations />
      {searchResults.length > 0 && <SearchResultsTabs />}
    </div>
  );
};

export default BulkLocations;
